import {
    FalkonDocUploadDateIcon,
    FalkonDocUploadSignIcon,
    FalkonDocInitialIcon,
    FalkonDocUploadTextIcon,
    FalkonDocUploadCheckboxIcon,
} from "../../icon";

interface ConfiguredField {
    id: string;
    type: string;
    page: number;
    position: {
        x: number;
        y: number;
        width: number;
        height: number;
    };
    assignedTo: any;
    completed: boolean;
    completedAt?: string;
}

interface AgreementData {
    name: string;
    message: string;
    ownmail: string;
    copyEmails: string[];
    recipients: string[];
    deadline: string;
    autoDeleteDays: number;
    completionStatus: string;
    elements: ConfiguredField[];
}

interface Props {

}

const ConfiguredFieldDisplay: React.FC<{
    field: ConfiguredField;
    currentPage: number;
}> = ({ field, currentPage }) => {
    if (field.page !== currentPage) {
        return null;
    }
    const getFieldIcon = (type: string): JSX.Element => {
        switch (type.toLowerCase()) {
            case 'signature':
                return <FalkonDocUploadSignIcon />;
            case 'initials':
                return <FalkonDocInitialIcon />;
            case 'text':
                return <FalkonDocUploadTextIcon />;
            case 'date':
                return <FalkonDocUploadDateIcon />;
            case 'checkbox':
                return <FalkonDocUploadCheckboxIcon />;
            default:
                return <FalkonDocUploadTextIcon />;
        }
    };

    const getFieldLabel = (type: string) => {
        return type.charAt(0).toUpperCase() + type.slice(1).toLowerCase();
    };

    return (
        <div
            className={`field-label-wrapper h6-medium p-absolute d-flex align-center justify-center ${field.completed ? "completed" : "pending"}`}
            style={{
                left: field.position.x,
                top: field.position.y,
                width: field.position.width,
                height: field.position.height,
            }}
        >
            <span className="field-icon-container d-flex align-center justify-center">
                {getFieldIcon(field.type)}
            </span>
            <span className="field-label-text">
                {getFieldLabel(field.type)}
                {field.completed && ' ✓'}
            </span>

            <div className="field-assigned-email">
                {field.assignedTo?.email || 'Unknown'}
            </div>
        </div>
    );
};

export default ConfiguredFieldDisplay;